





























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TweeningNumber from '@/components/forms/fields/TweeningNumber';
import OrderProductVariant from '@/zenky/interfaces/orders/OrderProductVariant';
import Product from '@/zenky/interfaces/products/Product';
import ProductVariant from '@/zenky/interfaces/products/ProductVariant';
import { Trash2Icon, MinusIcon, PlusIcon } from 'vue-feather-icons';
import Spinner from '@/components/Spinner.vue';
import { formatPriceRub } from '@/helpers/utils';

type ChangeQuantityEventBase = {
  type: 'incOrDec' | 'set',
  variantId: ProductsTable['orderVariants'][number]['product_variant_id'],
}
type IncOrDecQuantityEvent = ChangeQuantityEventBase & {
  type: 'incOrDec',
  quantityDelta: number,
};
type SetQuantityEvent = ChangeQuantityEventBase & {
  type: 'set',
  newQuantity: number,
};
export type ChangeQuantityEvent<T extends (IncOrDecQuantityEvent | SetQuantityEvent)['type'] = 'incOrDec' | 'set'> =
  T extends 'set'
    ? SetQuantityEvent
    : IncOrDecQuantityEvent;

@Component({ components: { Trash2Icon, MinusIcon, PlusIcon, TweeningNumber, Spinner } })
export default class ProductsTable extends Vue {
  @Prop({ type: Array, required: true }) readonly orderVariants!:
    Array<OrderProductVariant & { product: Product, variant: ProductVariant }>;
  @Prop({ type: Array, default: () => [] }) readonly quantityPendingFor!:
    Array<this['orderVariants'][number]['product_variant_id']>;

  onInputApply(variant: this['orderVariants'][number], inputVal: string) {
    const parsed = parseInt(inputVal, 10);
    if (parsed === variant.quantity || !Number.isSafeInteger(parsed) || parsed < 0) {
      return;
    }
    const payload: SetQuantityEvent = { type: 'set', variantId: variant.product_variant_id, newQuantity: parsed };
    this.$emit(this.eventName, payload);
  }
  get eventName() {
    return 'change-quantity';
  }
  private get formatPriceRub() { return formatPriceRub; }
}
